import React, { FC } from "react";
import { Radio as MuiRadio, RadioProps } from "@mui/material";

import IconRadioChecked from "@icons/RadioChecked";
import IconRadio from "@icons/Radio";

const Radio: FC<RadioProps> = (props) => (
  <MuiRadio icon={<IconRadio />} checkedIcon={<IconRadioChecked />} {...props} />
);

export default Radio;
